export const PAGE_SIZE = 50
export const TABLE_HEIGHT_HOME = '895px'
export const TABLE_HEIGHT_DEFAULT = '250px'
export const TABLE_HEIGHT_PROMISE2PAY = '1450px'

export const BPAY_REMITTANCE = 'BPAY'
export const ABA_REMITTANCE = 'ABA'
export const BOTH_REMITTANCE = 'BOTH'